import LoginForm from "../../Components/auth/LoginForm";
import Header from "../../Components/header/Header";

import "./Login.css";

export default function Login() {
  return (
    <div className="login-page">

      {/* Top Border */}
      <div className="login-top-border"></div>

      {/* Header */}
      <Header />

      {/* Main Section */}
      <div className="login-main-container">

        {/* Left Image */}
        <div className="login-left-section">
          <img
            src="/mountain.webp"
            alt="Mountain"
            className="login-bg-image"
          />
        </div>

        {/* Right Form */}
        <div className="login-right-section">
          <LoginForm />
        </div>

      </div>
    </div>
  );
}